export default __webpack_public_path__ + "static/media/ElenaHHNN.6f23c439.pdf";